import StageFileRow from './StageFileRow.component';

export default StageFileRow;
